import { OneSignal } from './onesignal';

export default new OneSignal();
